module.exports = __webpack_public_path__ + "img/LOGO.bb797921.png";